import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import { sortByProp } from "util/sort-by-prop";
import { Box } from "view/layout/box";

const sortByKeyAsc = sortByProp.bind(null, "k", "asc");

class ParameterForm extends React.PureComponent {
  static get propTypes() {
    return {
      params: PropTypes.object,
      readonly: PropTypes.bool.isRequired,
    };
  }

  static get defaultProps() {
    return {
      params: {},
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      params: this._getParamState(props.params),
    };

    this._add = this._add.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;
    const paramsChanged = !isEqual(params, prevProps.params);

    if (paramsChanged) {
      this.setState({ params: this._getParamState(params) });
    }
  }

  _getParamState(_params) {
    const params = Object.entries(_params)
      .map(([k, v]) => ({ k, v }))
      .sort(sortByKeyAsc);

    return params;
  }

  _remove(idx) {
    const params = cloneDeep(this.state.params);
    params.splice(idx, 1);

    this.setState({ params });
  }

  _add() {
    const params = cloneDeep(this.state.params);

    params.push({ k: "", v: "" });

    this.setState({ params });
  }

  _update(idx, type, value) {
    const params = cloneDeep(this.state.params);

    params[idx][type] = value;

    this.setState({ params });
  }

  getParams() {
    const { params } = this.state;

    return params
      .filter(({ k }) => Boolean(k))
      .reduce((acc, { k, v }) => {
        acc[k] = v;

        return acc;
      }, {});
  }

  _renderAddParamButton(hasParameter) {
    const { readonly } = this.props;

    return (
      <Button
        id="addButton"
        className="pull-right"
        variant={hasParameter ? "primary" : "default"}
        disabled={readonly}
        onClick={this._add}
      >
        <i className="fa fa-plus" /> Add Parameter
      </Button>
    );
  }

  _renderParams() {
    const { params } = this.state;

    return (
      <div>
        <Row>
          <Col xs={4}>
            <strong>Parameter Name</strong>
          </Col>
          <Col xs={8}>
            <strong>Parameter Value</strong>
          </Col>
        </Row>
        {params.map(this._renderParam, this)}
      </div>
    );
  }

  _renderParam({ k, v }, idx) {
    const { readonly } = this.props;

    const changeKey = (e) => {
      this._update(idx, "k", e.currentTarget.value);
    };
    const changeValue = (e) => {
      this._update(idx, "v", e.currentTarget.value);
    };
    const removeButton = (
      <Button
        variant="danger"
        disabled={readonly}
        onClick={this._remove.bind(this, idx)}
        id={`prem-${idx}`}
      >
        <i className="fa fa-minus" />
      </Button>
    );

    return (
      <Row key={`param-${idx}`}>
        <Col xs={4}>
          <FormGroup>
            <FormControl
              type="text"
              disabled={readonly}
              id={`pname-${idx}-control`}
              onChange={changeKey}
              value={k}
            />
          </FormGroup>
        </Col>
        <Col xs={8}>
          <FormGroup>
            <InputGroup>
              <FormControl
                type="text"
                disabled={readonly}
                id={`pval-${idx}-control`}
                onChange={changeValue}
                value={v}
              />
              <InputGroup.Append>{removeButton}</InputGroup.Append>
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  render() {
    const { params } = this.state;
    const hasParameter = params.length > 0;

    if (hasParameter) {
      return (
        <div>
          <Row>
            <Col xs={12}>{this._renderAddParamButton(hasParameter)}</Col>
          </Row>
          <Box noHeader={true}>{this._renderParams()}</Box>
        </div>
      );
    }

    return (
      <Row>
        <Col xs={12}>{this._renderAddParamButton(hasParameter)}</Col>
      </Row>
    );
  }
}

export { ParameterForm };
